<template>
    <div class="draft-item" @click="handle(item)">
        <h4 class="ell">【{{ item.category_name }}】{{ item.item_name }}</h4>
        <div v-if="sourceType == 'receivedGridExample'">
            <p class="ell">发起时间: {{ item.send_time }}</p>
            <p class="ell">接收时间：{{ item.receive_time }}</p>
        </div>

        <div v-if="sourceType == 'sendGridEximpl'">
            <p class="ell">办理时间: {{ item.done_time }}</p>
        </div>

        <div v-if="sourceType == 'initiatedEximpl'">
            <p class="ell">发起时间: {{ item.send_time }}</p>
        </div>

        <div v-if="sourceType == 'draftsEximpl'">
            <p class="ell">保存时间: {{ item.operate_time }}</p>
        </div>

        <div v-if="sourceType == 'sendMyGridEximpl'">
            <p class="ell">抄送时间: {{ item.operate_time }}</p>
        </div>

        <div class="box">
            <p class="ell" v-if="sourceType == 'receivedGridExample'" style="display: flex;justify-content: end;">
                <span class="boxStatusRed" v-if="item.handleStatus == '0'">{{ item.handleStatus | handleStatus }}</span>
                <span class="boxStatusBlue" v-if="item.handleStatus == '1'">{{ item.handleStatus | handleStatus }}</span>
                
            </p>
            <p class="ell" v-if="sourceType == 'receivedGridExample' || sourceType == 'sendGridEximpl'  || sourceType == 'sendMyGridEximpl'">
                发起人：{{ item.sender_name }}
            </p>
            <p class="ell">来源：{{ item.source_name }}</p>
        </div>
    </div>
</template>

<script>
    import { updateHandleStatus } from "@/api/MineMore"
    export default {
        name: "ExampleItem",
        props: ["item", "sourceType"],
        filters: {
            // 0 未读 1 已读  2 '超时未读 3 督办
            handleStatus(status) {
                switch (status) {
                    case "0":
                        return "未读"
                    case "1":
                        return "已读"
                    case "2":
                        return "超时未读"
                    case "3":
                        return "督办"
                }
            },
        },
        created() {
            console.log(this.sourceType)
        },
        methods: {
            handleStatusCell(item) {
                let params = {
                    item_id: item.item_code,
                    source_code: item.source_code,
                }
                updateHandleStatus(params).then(res => {
                    if (res.code == 200) {
                        // this.$emit("update")
                        //提示更新成功
                        Toast("更新成功")
                    }
                })
            },
            handle(item) {
                // var url = link + '&sourceType=' + this.sourceType;
                // location.href = url
                if (item && item.source_code == "serviceall") {
                    location.href = item.detailMobileUrl
                    this.handleStatusCell(item)
                } else {
                    window.location.href = item.detailMobileUrl
                    this.handleStatusCell(item)
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .draft-item {
        padding: 15px;
        padding-right: 180px;
        margin-bottom: 15px;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        background: #fff;
        position: relative;
        h4 {
            height: 30px;
            line-height: 30px;
            font-size: 14px;
        }
        p {
            line-height: 20px;
            font-size: 12px;
            color: #999;
        }
        .box {
            width: 145px;
            padding: 10px 0;
            text-align: center;
            position: absolute;
            right: 15px;
            top: 14px;
            border-radius: 5px;
            p {
                font-size: 14px;
                color: #999;
                text-align: left;
            }
            .boxStatusRed {
                width: 50px;
                height: 20px;
                display: block;
                border-radius: 5px;
                border: 1px solid #f00;
                text-align: center;
                color: #f00;
            }
            .boxStatusBlue {
                width: 50px;
                height: 20px;
                display: block;
                border-radius: 5px;
                border: 1px solid #00FF00;
                text-align: center;
                color: #00FF00;
            }
        }
    }

    .ell {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
